<nav-bar *ngIf="autenticado" titulo="PAINEL DE APLICAÇÕES" (logoutEvent)="logout($event)" [iconeNotificacoes]="false"
    [botaoPainelAplicacoes]="false" [menuItems]="menuOptions"></nav-bar>
<router-outlet></router-outlet>